import React from "../_snowpack/pkg/react.js";
import App from "../components/app.js";
import styled from "../_snowpack/pkg/@emotion/styled.js";
import {Title} from "../components/typo.js";
import Stack from "../components/stack.js";
import ContentModules from "../components/content-modules.js";
import {getTranslatedName} from "../common/utils.js";
import {media} from "../components/theme.js";
export default function Page(props) {
  return /* @__PURE__ */ React.createElement(App, {
    ...props
  }, /* @__PURE__ */ React.createElement(MainContainer, null, /* @__PURE__ */ React.createElement(H1, {
    level: 1
  }, /* @__PURE__ */ React.createElement("span", {
    dangerouslySetInnerHTML: {__html: getTranslatedName(props)}
  })), /* @__PURE__ */ React.createElement(Stack, {
    spacing: "l"
  }, props.content.modules && /* @__PURE__ */ React.createElement(ContentModules, {
    modules: props.content.modules,
    isProductPage: true
  }))));
}
const MainContainer = styled.div`
  padding-top: 32px;
`;
const H1 = styled(Title)`
  font-size: 58px;
  margin-bottom: 16px;

  ${media.mobile} {
    font-size: 42px;
  }
`;
